<template>
  <EditUserEmailForm :user-email="userEmail"
                     :user-emails-count="userEmailsCount"
                     @formSubmit="formSubmitted($event)"
                     @clickDestroy="clickDestroy($event)"
                     @updateUserEmail="updateUserEmail" />
</template>
<script>
import store from "./UserEmailStore";
import EditUserEmailForm from "./EditUserEmailForm.vue";
import UserEmailMixin from "./UserEmailMixin";

const responseStore = {
  response: null
};

export default {
  name: "UserEmailEdit",

  title () {
    return `Edit Email - ${Dashboard.currentTenant.name}`;
  },

  components: {
    EditUserEmailForm
  },

  mixins: [UserEmailMixin],

  data: function () {
    return {
      userEmail: null,
      userEmailsCount: null,
      responseStore: responseStore
    };
  },

  beforeMount () {
    this.userEmail = this.user.user_emails.find(userEmail => userEmail.id == this.$route.params.id);
    this.userEmailsCount = this.user.user_emails.length;
  },

  mounted () {
    this.addBreadcrumb(this.userEmail.email);
  },

  methods: {
    formSubmitted (e) {
      this.updateResource();
      e.preventDefault();
    },

    async clickDestroy (e) {
      this.handleResponse(await store.delete(this.userEmail.id));
    },

    async updateResource () {
      let responseJSON =
        await store.verifyUserEmail(this.user.id, this.userEmail.id);

      if (responseJSON.success) {
        this.notifySuccess(responseJSON.successMessage);
      } else {
        this.notifyErrors(responseJSON.errorMessages);
      }
    },

    updateUserEmail (updatedUserEmail) {
      this.userEmail.email = updatedUserEmail.email;
    }
  }
};
</script>
